/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class DashboardDefinitionAclEntryTenant extends models.DashboardDefinitionAclEntry {
    constructor() {
        super();
        this.setDiscriminator("tenant");
    }

    getFixupPrototypeFunction() { return DashboardDefinitionAclEntryTenant.fixupPrototype; }

    static newInstance(model: Partial<DashboardDefinitionAclEntryTenant>): DashboardDefinitionAclEntryTenant {
        let obj = Object.assign(new DashboardDefinitionAclEntryTenant(), model);
        DashboardDefinitionAclEntryTenant.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<DashboardDefinitionAclEntryTenant>): DashboardDefinitionAclEntryTenant {
        if (!model) return null;
        return DashboardDefinitionAclEntryTenant.newInstance(<DashboardDefinitionAclEntryTenant> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: DashboardDefinitionAclEntryTenant) {
        if (!obj) return;

        models.DashboardDefinitionAclEntryTenant.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: DashboardDefinitionAclEntryTenant): boolean {
        if (models.DashboardDefinitionAclEntry.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, DashboardDefinitionAclEntryTenant.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
        if (this.roles) {
            for (let val of this.roles) {
                models.DashboardDefinitionAclRole.fixupPrototype(val);
            }
        }
    }

    account_id: string;

    tenant_id: string;

    roles: Array<models.DashboardDefinitionAclRole>;

}
